import React, { PureComponent } from 'react';
import { Field, reduxForm, Form } from 'redux-form';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import AlternateEmailIcon from 'mdi-react/AlternateEmailIcon';
import PropTypes from 'prop-types';
import { Alert, Button } from 'reactstrap';
import { useBasicAuth } from '../auth/withBasicAuth';

class ResetPasswordForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
  };

  constructor(props) {
    super();
    this.state = {
      message: '',
    };

    this.showError = this.showError.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  showError(msg){
    this.setState({ message: msg });
  }

  handleSubmit(e){
    useBasicAuth.resetPassword(e.username, this.showError); 
  }

  render() {
    const {
      handleSubmit, t,
    } = this.props;
    const { message } = this.state;

    let msg = "";
    if(message !== ''){
      msg = t('forms.login_form.'+message);
    }

    return (
      <div className="account account--photo2">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head-minerblue">
              {/* <h3 className="account__title">{t('forms.login_form.account__title')}
                <span className="account__logo"> {t('forms.login_form.account__logo')}
                  <span className="account__logo-accent">{t('forms.login_form.account__logo-accent')}</span>
                </span>
              </h3>
              <h4 className="account__subhead subhead">{t('forms.login_form.PasswordReset')}</h4> */}
              <span className="login__logo2" />
              <h4 className="account__subhead subhead__login2">{t('forms.login_form.PasswordReset')}</h4>
            </div>
            <Form className="form login-form" onSubmit={handleSubmit(this.handleSubmit)}>
              <Alert
                color="danger"
                isOpen={!!msg}
              >
                {msg}
              </Alert>
              <div className="form__form-group">
                <span className="form__form-group-label" style={{color: "#aaaaaa"}}>{t('forms.login_form.email')}</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-icon">
                    <AlternateEmailIcon />
                  </div>
                  <Field
                    name="username"
                    component="input"
                    type="text"
                    placeholder={t('forms.login_form.email_ex')}
                    className="input-without-border-radius"
                  />
                </div>
              </div>
              <div className="account__btns register__btns">
                <Button type="submit" color="minerblue" className="account__btn">
                {t('forms.login_form.ResetPassword')}
                </Button>
              </div>
            </Form>
            <div className="account__have-account-minerblue">
              <p>{t('forms.login_form.AlreadyHaveAccount')} <Link to="/log_in">{t('forms.login_form.login')}</Link></p>
            </div>
          </div>
        </div>
      </div>

      
    );
  }
}

export default reduxForm({
  form: 'login_form', // a unique identifier for this form
})(withTranslation('common')(ResetPasswordForm));
